import React from 'react';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import check from '../../../../../../images/icon/check.svg';
import { includes, isArray, map } from 'lodash';
import { FormErrorMessage } from '../FormErrorMessage.jsx';

export class SelectboxForm extends BasicForm {
  state = {
    isOpen: false,
  }

  handleMultipleChoice(mode = 'toggle', input, value) {
    switch (mode) {
      case 'toggle':
        return input.value === value
          ? ''
          : value;
      case 'selection':
        const selections = input.value;
        return includes(selections, value)
          ? selections.filter(d => d !== value)
          : selections.concat([value]);
    }
  }

  isSelectedMultipleChoice(mode = 'toggle', input, value) {
    switch (mode) {
      case 'toggle':
        return input.value === value;
      case 'selection':
        return isArray(input.value) && includes(input.value, value);
    }
  }

  handleTouch(e, mode = 'toggle') {
    e.preventDefault();
    this.setState(preState => ({ isOpen: !preState.isOpen }));
  }


  handleSelect(e, candidate) {
    const { input, object: { data: { mode = 'toggle' } }, touch } = this.props;
    const value = this.handleMultipleChoice(mode, input, candidate.value)
    input.onChange(value);
    if (mode === 'toggle') this.setState({ isOpen: false });
    touch(input.name);
  }

  getPlaceholder(mode = 'toggle', value, candidates = [], placeholder) {
    switch (mode) {
      case 'selection':
        const labels = candidates.filter(candidate => value.includes(candidate.value)).map(candidate => candidate.label);
        return labels.length ?
          labels.length === 1
            ? labels[0]
            : `選択数：${labels.length}件`
          : <span className='cu-ui-select-placeholder'>{placeholder}</span>;
      case 'toggle':
        const label = candidates.find(candidate => value === candidate.value)?.label;
        return label ? label : <span className='cu-ui-select-placeholder'>{placeholder}</span>;
    }
  }

  handleSelectAll(input, candidates) {
    input.onChange(candidates.map(candidate => candidate.value));
  }

  handleInitialSelect(input, candidate) {
    input.onChange(candidate);
  }

  handleClear(input) {
    input.onChange([]);
  }

  componentDidMount() {
    const { input, object: { data: { mode, initial_value } } } = this.props;
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (!this.state.isOpen) return;
    if (this.selectRef && !this.selectRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  render() {
    const { disabled, input, meta, object: { label, data: { placeholder, mode, candidates }, validations } } = this.props;

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={label}
          required={validations.required}
        />
        <div className='cu-ui-input-container cu-ui-select-dropdown'>
          <div className={`cu-ui-select ${disabled ? 'disabled' : ''}`} ref={(node) => this.selectRef = node}>
            <div className="cu-ui-select-trigger" onClick={(e) => !disabled && this.handleTouch(e, mode)}>
              {this.getPlaceholder(mode, input.value, candidates, placeholder)}
            </div>
            <div className={`cu-ui-select-options ${this.state.isOpen ? 'open' : ''}`}>
              {mode === 'selection' && (
                <div className='cu-ui-select-dropdown-header'>
                  <button className='cu-ui-select-dropdown-header-button' type="button" onClick={() => this.handleSelectAll(input, candidates)}>全選択</button>
                  <button className='cu-ui-select-dropdown-header-button' type="button" onClick={() => this.handleClear(input)}>クリア</button>
                </div>
              )}
              <div className='cu-ui-select-dropdown-body'>
                {candidates?.map(candidate => (
                  <div
                    className={`cu-ui-select-option ${this.isSelectedMultipleChoice(mode, input, candidate.value) && 'selected'}`}
                    onClick={(e) => { this.handleSelect(e, candidate) }}
                    key={candidate.value}
                    data-value={candidate.value}>
                    {candidate.label}
                    {this.isSelectedMultipleChoice(mode, input, candidate.value) && <img src={check} alt="check" />}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <FormErrorMessage
          error={meta.error}
          touched={meta.touched}
        />
      </div>
    );
  }
}
